import { TagDetailsFormWebComponent } from './component/TagDetailsFormWebComponent';
import { WEB_COMPONENT_TAG_DETAILS_FORM } from '../../../webcomponents.constants';

export { TagDetailsFormWebComponent };

window.customElements.define(WEB_COMPONENT_TAG_DETAILS_FORM, TagDetailsFormWebComponent);
